var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more"},[_c('a',{staticClass:"more-btn",attrs:{"type":"button","href":_vm.url},on:{"click":_vm.showMore}},[_vm._v(_vm._s(_vm.SHOW_MORE))])])
}
var staticRenderFns = []

export { render, staticRenderFns }